<template>
  <div class="home">
    <!-- 定位中的 Loading -->
    <div v-if="isLocating" class="loading-overlay">
      <div class="spinner"></div>
      <p>正在定位中...</p>
    </div>

    <!-- 主要內容 -->
    <Delivery
      ref="deliveryComponent"
      :noAuth="noAuth"
      msg="Delivery"
    />
    <Footer msg="Footer" />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Delivery from "@/components/Delivery.vue";
import geolocationMixin from "@/mixins/geolocationMixin";

export default {
  name: "home",

  components: {
    Footer,
    Delivery
  },

  mixins: [geolocationMixin],

  data() {
    return {
      noAuth: false
    };
  },

  async mounted() {
    console.log('Home mounted, checking geolocation...');

    // 首次訪問或使用快取的定位
    await this.autoGeolocation();
  },

  methods: {
    /**
     * 實作 mixin 要求的方法：套用定位篩選
     * 直接用使用者座標計算距離，篩選前 N 間最近的店家
     */
    applyGeolocationFilter(coords) {
      console.log('Applying geolocation filter:', coords);

      // 通知 Delivery 元件用距離篩選
      if (this.$refs.deliveryComponent && this.$refs.deliveryComponent.filterByDistance) {
        this.$refs.deliveryComponent.filterByDistance(coords, {
          limit: 60,        // 顯示前 60 間最近的店家
          maxRadius: 0     // 最大搜尋半徑 0km
        });
      } else {
        console.warn('Delivery component does not have filterByDistance method yet');
        // 暫時使用現有的篩選機制（如果 Delivery 元件還沒實作 filterByDistance）
        console.log('User location:', coords);
      }

      // 更新 localStorage（儲存座標用於地圖中心）
      localStorage.setItem('userLocation', JSON.stringify({
        lat: coords.lat,
        lng: coords.lng,
        timestamp: Date.now()
      }));
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  color: white;
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
